export default __webpack_public_path__ + "static/imda-915623a94708c5fc0c2a9ab60d857cc8.png";